import Content from '../../content';

namespace('IO.Views.Stores', function (exports) {
  'use strict';

  exports.PaymentConfig = Content;
});
